(() => {
  // Ask Shopify's option-value renderer, never a truncated product.variants array.
  const navigate = (picker) => {
    const selects = [...picker.querySelectorAll('select[data-option-position]')];
    const values = selects.sort((a,b) => +a.dataset.optionPosition - +b.dataset.optionPosition).map(s => s.value);
    if (values.some(v => !/^\d+$/.test(v))) return;
    const url = new URL(location.href);
    url.searchParams.delete('variant');
    url.searchParams.delete('section_id');
    url.searchParams.set('option_values', values.join(','));
    url.hash = picker.closest('form')?.getAttribute('id') || '';
    picker.setAttribute('aria-busy', 'true');
    picker.closest('form')?.querySelectorAll('[name="id"], [name="add"]').forEach(c => { c.disabled = true; });
    location.assign(url.toString());
  };
  const init = async (picker) => {
    if (picker.dataset.initialized) return;
    picker.dataset.initialized = 'true';
    const selects = [...picker.querySelectorAll('select[data-option-position]')];
    const byRank = rank => selects.find(s => s.dataset.optionRank === rank);
    const style = byRank('1'), color = byRank('2'), size = byRank('3');
    if (!style || !color || !size || selects.length !== 3) return;
    picker.dataset.compatibilityPicker = 'true';
    const originalColors = [...color.options].map(o => ({id:o.value, name:o.dataset.optionLabel}));
    const originalSizes = [...size.options].map(o => ({id:o.value, name:o.dataset.optionLabel}));
    [...style.options].forEach(o => { o.textContent = o.dataset.optionLabel; });
    const status = document.createElement('p');
    status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
    status.style.gridColumn = '1 / -1'; picker.append(status);
    const form = picker.closest('form');
    const controls = [...form.querySelectorAll('[name="id"], [name="add"]')];
    const initialDisabled = controls.map(c => c.disabled);
    const checkout = form.querySelector('.shopify-payment-button');
    const price = form.parentElement.querySelector('[data-product-price]');
    const initialPrice = price?.textContent;
    const lock = () => { form.classList.add('sff-options-pending'); controls.forEach(c => { c.disabled = true; }); if(checkout) checkout.hidden = true; if(price) price.textContent = 'Choose your style, color and size'; };
    const cache = new Map(); let generation = 0; let matrix;
    const loadStyle = (styleId) => {
      if (!cache.has(styleId)) cache.set(styleId, (async () => {
        const result = new Map(); let next = 0;
        await Promise.all(Array.from({length:Math.min(3,originalSizes.length)}, async () => {
          while(next < originalSizes.length) {
            const item = originalSizes[next++];
            const url = new URL(location.href);
            url.hash = ''; url.searchParams.delete('variant');
            url.searchParams.set('section_id', picker.dataset.sectionId);
            url.searchParams.set('option_values', [styleId,item.id].join(','));
            const response = await fetch(url, {credentials:'same-origin'});
            if(!response.ok) throw new Error('Option check failed');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const resolved = doc.querySelector('[data-option-dropdowns]');
            const selectedStyle = resolved?.querySelector('select[data-option-rank="1"] option[selected]');
            const selectedSize = resolved?.querySelector('select[data-option-rank="3"] option[selected]');
            if(selectedStyle?.value !== styleId || selectedSize?.value !== item.id) throw new Error('Option identity mismatch');
            const row = new Map();
            resolved.querySelectorAll('select[data-option-rank="2"] option[data-variant-exists="true"]').forEach(o => row.set(o.value, o.dataset.variantAvailable === 'true'));
            result.set(item.id,row);
          }
        }));
        return result;
      })().catch(error => {cache.delete(styleId); throw error;}));
      return cache.get(styleId);
    };
    const fill = (select, items, value, prompt) => {
      select.replaceChildren();
      if(!items.some(i => i.id === value)) {
        const placeholder = new Option(prompt,'',true,true); placeholder.disabled = true; select.add(placeholder);
      }
      items.forEach(i => select.add(new Option(i.name,i.id,false,i.id === value)));
    };
    const reconcile = () => {
      const colorId = color.value, sizeId = size.value;
      fill(color, originalColors.filter(c => [...matrix.values()].some(row => row.has(c.id))),colorId,'Choose a color for this style');
      fill(size, originalSizes.filter(s => matrix.get(s.id)?.has(color.value)).map(s => ({...s,name:s.name + (matrix.get(s.id).get(color.value) ? '' : ' — Sold out')})),sizeId,'Choose a size for this color');
      const valid = color.value && size.value && matrix.get(size.value)?.has(color.value);
      status.textContent = valid ? '' : color.value ? 'Please choose a size offered for this style and color.' : 'Please choose a color offered for this style, then confirm your size.';
      return valid;
    };
    const refresh = async (initial=false) => {
      const token = ++generation; lock(); color.disabled = true; size.disabled = true;
      status.textContent = 'Checking colors and sizes for this style…'; picker.setAttribute('aria-busy','true');
      try {
        const data = await loadStyle(style.value);
        if(token !== generation) return;
        matrix = data; color.disabled = false; size.disabled = false; picker.removeAttribute('aria-busy');
        const valid = reconcile();
        if(initial && valid) {form.classList.remove('sff-options-pending'); if(price) price.textContent = initialPrice; controls.forEach((c,i) => {c.disabled = initialDisabled[i];}); if(checkout) checkout.hidden = false;}
        else if(valid) navigate(picker);
      } catch(error) {
        if(token !== generation) return;
        picker.removeAttribute('aria-busy');
        status.textContent = 'We could not verify these options. Please refresh the page before choosing a different style.';
      }
    };
    picker.addEventListener('change', event => {
      if(!selects.includes(event.target)) return;
      event.stopPropagation(); lock();
      if(event.target === style) refresh();
      else if(matrix && reconcile()) navigate(picker);
    });
    await refresh(true);
  };
  document.querySelectorAll('[data-option-dropdowns]').forEach(init);
  document.addEventListener('change', event => {
    const picker = event.target.closest('select[data-option-position]')?.closest('[data-option-dropdowns]');
    if(picker && !picker.dataset.compatibilityPicker) navigate(picker);
  });
  window.addEventListener('pageshow', event => {
    if(event.persisted && document.querySelector('[data-option-dropdowns]')) location.reload();
  });
})();
